import { render, staticRenderFns } from "./DataComplianceDetail.vue?vue&type=template&id=555e7446&scoped=true"
import script from "./DataComplianceDetail.vue?vue&type=script&lang=js"
export * from "./DataComplianceDetail.vue?vue&type=script&lang=js"
import style0 from "./DataComplianceDetail.vue?vue&type=style&index=0&id=555e7446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e7446",
  null
  
)

export default component.exports